// extracted by mini-css-extract-plugin
export default {"root":"srFKq1d7"};